// Angular imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// 3rd party imports
import {
    DxBoxModule,
    DxButtonModule,
    DxLoadPanelModule,
    DxScrollViewModule,
    DxProgressBarModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxValidationGroupModule,
    DxTextAreaModule,
    DxResponsiveBoxModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxFormModule,
    DxNumberBoxModule
} from 'devextreme-angular';
import { RecaptchaModule } from 'ng-recaptcha';

// CC-Common imports
import { CCCommonModule } from 'cc-common';

// Component imports
import { LoginComponent } from './login/login.component';
import { CommonUserAuthenticationLayoutComponent } from './common-user-authentication-layout/common-user-authentication-layout.component';
import { WelcomeMessageComponent } from './welcome-message/welcome-message.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PreferencesComponent } from './preferences/preferences.component';

// Module imports
import { UserRoutingModule } from './user-routing.module';

@NgModule({
    declarations: [
        LoginComponent,
        CommonUserAuthenticationLayoutComponent,
        WelcomeMessageComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        PreferencesComponent
    ],
    exports: [PreferencesComponent],
    imports: [
        CommonModule,
        DxBoxModule,
        DxButtonModule,
        DxTextAreaModule,
        DxTextBoxModule,
        DxValidationGroupModule,
        DxValidatorModule,
        DxResponsiveBoxModule,
        DxLoadPanelModule,
        DxScrollViewModule,
        DxProgressBarModule,
        DxPopupModule,
        DxSelectBoxModule,
        DxFormModule,
        DxNumberBoxModule,
        RecaptchaModule,
        CCCommonModule,
        UserRoutingModule
    ]
})
export class UserModule {}
